import { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import NetworkBackground from '../../components/NetworkBackground';
import authService from '../../services/authService';
import styles from './ForgotPasswordPage.module.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className={styles.pageWrapper}>
        <NetworkBackground />
        <div className={styles.card}>
          <h1 className={styles.title}>Invalid Link</h1>
          <p className={styles.message}>This password reset link is invalid. Please request a new one.</p>
          <Link to="/forgot-password" className={styles.backLink}>Request reset link</Link>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    setError('');
    const result = await authService.resetPassword(token, password);
    setLoading(false);
    if (result.success) {
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.card}>
        <div className={styles.logoContainer}>
          <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
          <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
        </div>

        {done ? (
          <>
            <div className={styles.iconWrapper}>
              <svg className={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className={styles.title}>Password reset!</h1>
            <p className={styles.message}>Your password has been updated. Redirecting to login…</p>
            <Link to="/login" className={styles.backLink}>Go to Login</Link>
          </>
        ) : (
          <>
            <h1 className={styles.title}>Set new password</h1>
            <p className={styles.message}>Choose a strong password of at least 8 characters.</p>

            {error && <div className={styles.errorMessage}>{error}</div>}

            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                className={styles.input}
                type="password"
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
                required
                autoFocus
              />
              <input
                className={styles.input}
                type="password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
              <button type="submit" className={styles.button} disabled={loading}>
                {loading ? 'Saving…' : 'Reset password'}
              </button>
            </form>

            <div className={styles.divider}></div>
            <div className={styles.footerText}>
              <Link to="/login">Back to Login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
